import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { getServiceNameWithNickname } from "../../../utils/getServiceNameWithNickname";
import Notification from "../../elements/notification/Notification";
import FeeEditForm from "./FeeEditForm";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { Alert } from "@material-ui/lab";
import { useHistory } from "react-router-dom";
import GoToBackButton from "../../elements/goToBack/GoToBack";
import { TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledFeeDetailsWrapper } from "../styledFee";
import { StyledBlockLabel, StyledFormBlock, StyledFormGrid, StyledInputBlock } from "../../styles/styledTabsForm";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";

const FeeDetailsContainer = ({ match }) => {
  const { t } = useTranslation("feePage");

  const [fee, setFee] = useState();
  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    axios.get("/api/base-fees/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setFee(response.data);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }, []);

  if (!fee) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (fee.length === 0) {
    return <Alert severity="warning">{t("details.changeForm.emptyData")}</Alert>;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{fee.paymentSystem.name} ({fee.service.name}) - {t("details.meta.title")} {fee.service.name} • eXsoft.io</title>
        </Helmet>
        <StyledFeeDetailsWrapper>
          <GoToBackButton
            handler={() => {history.goBack();}}
            pt="20"
            pb="30"
          />
          <StyledFormGrid>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("details.changeForm.paymentSystem")}
              </StyledBlockLabel>
              <StyledInputBlock>
                <TextField
                  className="grid-form__input"
                  label={t("details.changeForm.service")}
                  type="text"
                  value={getServiceNameWithNickname(fee.service.name, fee.service.nickname)}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("details.changeForm.paymentSystem")}
                  type="text"
                  value={fee.paymentSystem.name}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("details.changeForm.currency")}
                  type="text"
                  value={fee.currency.asset}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("details.changeForm.type")}
                  type="text"
                  value={fee.type}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
              </StyledInputBlock>
              <div className="clear-column" />
            </StyledFormBlock>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("details.changeForm.fee")}
              </StyledBlockLabel>
              <FeeEditForm
                fee={fee}
                notification={notification}
                setNotification={setNotification}
                url="/api/base-fees/"
              />
              <div className="clear-column" />
            </StyledFormBlock>
          </StyledFormGrid>
        </StyledFeeDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default FeeDetailsContainer;